import { GetStaticProps, NextPage } from "next";

import { Seo } from "@/components";
import { type BlogPost, BlogCard, getAllBlogPosts } from "@/features/blog";

type Props = { blogs: BlogPost[] };

export const getStaticProps: GetStaticProps<Props> = async () => {
  const blogs = await getAllBlogPosts();

  return {
    props: { blogs },
  };
};

const BlogsPage: NextPage<Props> = ({ blogs }) => (
  <>
    <Seo templateTitle="Our blog" />

    <div className="container mt-16">
      <h1 className="text-center text-5xl font-medium">Our blog</h1>
      <p className="mx-auto mt-4 w-2/3 text-center">
        Thanks for checking out our epic blog, where we will be updating our community on the latest
        in sustainability, side hustling and much much more!
      </p>
      <div className="mt-8 mb-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-10">
        {blogs.map((blog) => (
          <BlogCard blog={blog} key={blog.UrlSlug} />
        ))}
      </div>
    </div>
  </>
);

export default BlogsPage;
